import Tabs from "@components/tabs/tabs";

export type IntegrationsScope = "organization" | "personal";

const IntegrationsScopeTabs = ({
  selectedScope,
  organizationId,
}: {
  selectedScope: IntegrationsScope;
  organizationId?: number | null;
}) => {
  const options: { value: IntegrationsScope; label: string; to?: string }[] =
    [];

  if (organizationId) {
    options.push({
      value: "organization",
      label: "Organization",
      to: `/settings/organization/${organizationId}/integrations`,
    });
  }

  options.push({
    value: "personal",
    label: "Personal",
    to: "/account/integrations",
  });

  if (options.length < 2) {
    return null;
  }

  return <Tabs options={options} selectedValue={selectedScope} />;
};

export default IntegrationsScopeTabs;
